import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import * as logo from '../_helpers/logo';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable';
import { ImageService } from './image.service';
interface ColumnColor {
  dataKey: string;
  r: number;
  g: number;
  b: number;
  key: string;
}
@Injectable({
  providedIn: 'root'
})
export class ExportDataService {
  monthNames:string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  constructor(private imageService:ImageService) {}

  exportExcel(rptData:any) {

    //Title, Header & Data
    const title = rptData.title;
    const header = rptData.headers;
    const data = rptData.data;
    const sheetname = rptData.sheetname;
    const file_extention = rptData.file_extention; // xlsx,xls,csv
    const searchterm=rptData.searchterm;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(sheetname);

    //Add Row and formatting
    worksheet.mergeCells('C1', 'F4');
    let titleRow = worksheet.getCell('C1');
    titleRow.value = title;
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' },
    };
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Date
    worksheet.mergeCells('G1:H4');
    let d = new Date();
    let date =
      d.getDate() + '-' + this.monthNames[d.getMonth()] + '-' + d.getFullYear();
    let dateCell = worksheet.getCell('G1');
    dateCell.value = date;
    dateCell.font = {
      name: 'Calibri',
      size: 12,
      bold: true,
    };
    dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

    //Add Image
    let PropertyLogoImg = workbook.addImage({
      base64: logo.imgBase64,
      extension: 'png',
    });
    worksheet.mergeCells('A1:B4');
    worksheet.addImage(PropertyLogoImg, 'A1:B4');

    //Blank Row
    worksheet.addRow([]);

    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4167B8' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12,
      };
    });

    // Search term
    worksheet.mergeCells('I1:Z4');
    let searchtermCell = worksheet.getCell('I1');
    searchtermCell.value ="SEARCH TERM : "+ searchterm;
    searchtermCell.font = {
      name: 'Calibri',
      size: 11,
      bold: false,
    };
    searchtermCell.alignment = { vertical: 'middle', horizontal:'left' };

    // Adding Data with Conditional Formatting
    data.forEach((d:any) => {
      let row = worksheet.addRow(d);

      //let Products = row.getCell(6);
      //let color = 'FF99FF99';
      // if (+Products.value < 200000) {
      //   color = 'FF9999';
      // }

      // Products.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color },
      // };
    });

    worksheet.getColumn(3).width = 20;
    worksheet.addRow([]);

    //Footer Row
    let footerRow = worksheet.addRow([
      'Report Generated from www.chemrobotics.com at ' + date,
    ]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' },
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, title + '.' + file_extention.replace('.', ''));
    });
  }
  
  exportPdf(rptData: any, columColor: ColumnColor[] = []) {
    // Title, Header & Data
    const title = rptData.title;
    const header = rptData.headers;
    const data = rptData.data;
  
    let columnstyle: any = {};
    header.forEach((element: any, i: any) => {
      columnstyle[i] = { cellWidth: 3 };
    });
  
    var doc = new jsPDF('p', 'in', [612, 792]);
    doc.addImage(logo.imgBase64, 'PNG', 0.2, 0, 0.5, 0.5);
  
    autoTable(doc, {
      columns: header,
      body: data,
      tableWidth: 'wrap',
      margin: { top: 0.5 },
      columnStyles: columnstyle,
      willDrawCell: (hookData) => {
        let x: ColumnColor | undefined = columColor.find(
          (color) => color.dataKey === hookData.column.dataKey
        );
  
        if (x) {
          doc.setFillColor(x.r, x.g, x.b);
          // For header, default black text color
          if (hookData.cell.text.join("") === x.key) {
            doc.setTextColor(0, 0, 0);
          }
        }
      },
      tableLineWidth: 0,
      styles: {
        overflow: 'linebreak'
      },
    });
  
    doc.save(title + '.pdf');
  }
}
